/**
 * JWT header structure.
 *
 * Standard JWT header with algorithm and type fields.
 *
 * @example
 * ```ts
 * const header: JWTHeader = { alg: "HS256", typ: "JWT" }
 * ```
 */
export type JWTHeader = {
  alg: string
  typ: string
}
